import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import { TokenAdornment } from './TokenAdornment/TokenAdornment';
import { TokenPicker } from './TokenPicker/TokenPicker';
import { useTokenizedInput } from './useTokenizedInput';
import { useTokenTrigger } from './useTokenTrigger';
const INERT = {
    inputRef: {
        current: null
    },
    onKeyDown: undefined,
    onClick: undefined,
    adornment: null,
    picker: null,
    isPickerOpen: false
};
export function useTokensField(param) {
    let { tokens, onValueChange, testIds } = param;
    var _adornmentConfig_testId;
    const inputRef = useRef(null);
    const { onKeyDown, onClick, insertToken, setValueWithCaret } = useTokenizedInput({
        inputRef,
        onChange: onValueChange,
        pattern: tokens === null || tokens === void 0 ? void 0 : tokens.pattern,
        onTokenClick: tokens === null || tokens === void 0 ? void 0 : tokens.onTokenClick
    });
    const trigger = useTokenTrigger({
        inputRef,
        insertToken,
        setValueWithCaret
    });
    const handleKeyDown = useCallback((event)=>{
        if (trigger.handleEscape(event)) return;
        const request = onKeyDown(event);
        if (request) trigger.openAt(request);
    }, [
        trigger,
        onKeyDown
    ]);
    const openFromAdornment = useCallback((element)=>trigger.openFrom(element), [
        trigger
    ]);
    useEffect(()=>{
        if (!(tokens === null || tokens === void 0 ? void 0 : tokens.triggerRef)) return;
        const ref = tokens.triggerRef;
        ref.current = openFromAdornment;
        return ()=>{
            ref.current = null;
        };
    }, [
        openFromAdornment,
        tokens
    ]);
    // WHY: a field with no tokens config gets one shared inert result — no handlers on its input, no
    // adornment in its end slot, nothing for React to diff.
    if (!tokens) return INERT;
    const adornmentConfig = tokens.adornment;
    const adornment = !adornmentConfig.hidden ? /*#__PURE__*/ _jsx(TokenAdornment, _object_spread_props(_object_spread({}, adornmentConfig), {
        label: adornmentConfig.label,
        onClick: openFromAdornment,
        testId: (_adornmentConfig_testId = adornmentConfig.testId) !== null && _adornmentConfig_testId !== void 0 ? _adornmentConfig_testId : testIds.adornment
    })) : null;
    return {
        inputRef,
        onKeyDown: handleKeyDown,
        onClick,
        adornment,
        picker: /*#__PURE__*/ _jsx(TokenPicker, {
            config: tokens.picker,
            trigger: trigger
        }),
        isPickerOpen: trigger.isOpen
    };
}
